import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from '@common/common.module';

/* Common Modules */
import { PerformanceRouterModule } from '@performance/performance.routes';

import { TableModule } from '@app/modules/table/table.module';

/* Common Resolve */
import { PerformanceResolver } from '@performance/performance.resolver';

/* Module Views */
import { Views } from '@performance/views';

/* Components */
import { Components } from '@performance/components';

import { PlatformModule } from '@app/platform.module';
import { PerformanceFormsModule } from '../forms/performance/performance-forms.module';

import { Services } from '@performance/services';

@NgModule({
    imports: [
        PerformanceRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        PerformanceFormsModule,
    ],
    declarations: [
        /* Views */
        ...Views,
        ...Components,
    ],
    providers: [PerformanceResolver, ...Services],
})
export class PerformanceModule {}
